import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import getCheckListPDF from './psc-general-checklist.pdf';
import { Link, Button } from '@mui/material';

const PSCChecklist = () => {
    return (
        <center>
            <Link href={getCheckListPDF} without="true" rel="noopener noreferrer" target="_blank" color="#FFFFFF">
                <Button variant="outline">
                    <DownloadIcon />
                </Button>
            </Link>
        </center>
    );
};
export default PSCChecklist;
